module.exports = __webpack_public_path__ + "images/307  Grande Suite - Balcon - The Babel Community Paris Montigny Coliving (1).jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/babel/307  Grande Suite - Balcon - The Babel Community Paris Montigny Coliving (1).jpg
// module id = 50
// module chunks = 0